import React, { useMemo } from "react";
import { useSelector } from "react-redux"; //for stack list
import { makeStyles } from "@mui/styles";
import {
  Autocomplete,
  FormControl,
  FormLabel,
  Checkbox,
  FormControlLabel,
  MenuItem,
  Input,
  InputLabel,
  Select,
  TextField,
  Radio,
  RadioGroup,
  Switch
} from "@mui/material";
import moment from "moment-timezone";
const useStyles = makeStyles((theme) => ({
  formControl: {
    flexDirection: "column",
    margin: theme.spacing(3),
    width: "calc(100% - 48px)",
  },
  timezoneContainer: {
    marginTop: theme.spacing(1),
    zIndex: 10,
  },
  option: {
    display: "inline-block",
    width: "100%",
    marginTop: "15px",
    marginBottom: "15px",
    borderBottom: "1px solid lightgray",
    "&:last-child": {
      borderBottom: 0,
    },
  },
}));

const dataTypeOptions = { "1": "In columns by tag", "2": "In rows by tag", "3": "Linearly (single column)" }

//options.start: timestamp of start of data range
//options.end: timestamp of end of data range
//options.include-errtok: flag to include errtok values (defaults to false)
//options.include-header: flag to include header in csv
//options.one-file: flag to combine all tags to a single file
//options.tag-columns: arrange in columns per tag
//options.time-sensitivity: collapse times in tag-columns (mS)
//options.recur-days: simple recurrance after a number of days (defaults to NOT recurring)
//options.execute-at: timestamp for when the job should execute (optional: defaults ot ASAP)
//options.acu_groups: permission to change

const ExportOption = (props) => {
  const { options, setOptions } = props;
  //console.log("props are",props);
  const classes = useStyles();
  const timeframe = options.timeframe;
  const orgs = useSelector((state) => state.isx.orgs);
  const stacks2orgs = useSelector((state) => state.isx.stacks2orgs);
  const stackOrgs = useMemo(() => {
    return Object.values(props.tagsSelected).reduce((acc, tag) => {
      const oids = stacks2orgs[tag.stack];
      if(oids) oids.forEach((a) => acc.add(a));
      return acc;
    }, new Set());
  }, [props.tagsSelected, stacks2orgs]);
  const availableGroups = useMemo(() => {
    return Object.fromEntries(
      Object.values(orgs || []).filter((g)=> stackOrgs.has(g.guuid)).map((g) => [g.guuid, {id: g.guuid, name: g.name}]));
  }, [stackOrgs, orgs])
  const groups = useMemo(
    () => (options.acu_groups || []).map((v) => {return {id:v, name:availableGroups[v]?.name || v }}),
    [options, availableGroups]);
  function updateGroups(val) {
    const x = { acu_groups: [...new Set(val.map(v=>v.id))] };
    console.log("UPDATING",x);
    setOptions(x);
  }

  return (
    <FormControl variant="standard" fullWidth={true} className={classes.formControl}>
      <FormLabel component="legend">Report Details</FormLabel>
      <FormControl variant="standard">
        <TextField
          variant="standard"
          id="fname"
          label="Name"
          value={options.fname ?? ""}
          onChange={(event) => {
            const val = event.target.value;
            setOptions({ fname: val });
          }}
          InputLabelProps={{ shrink: true }}
          margin="normal"
          style={{ width: "50%" }} />
      </FormControl>
      <FormControl variant="standard">
        <TextField
          variant="standard"
          id="note"
          label="Description"
          value={options.note ?? ""}
          onChange={(event) => {
            const val = event.target.value;
            setOptions({ note: val });
          }}
          InputLabelProps={{ shrink: true }}
          margin="normal" />
      </FormControl>
      <FormControl variant="standard">
        <TextField
          variant="standard"
          id="email"
          label="Email recipients (optional, comma separated)"
          value={options.email ?? ""}
          onChange={(event) => {
            const val = event.target.value;
            setOptions({ email: val });
          }}
          InputLabelProps={{ shrink: true }}
          margin="normal" />
      </FormControl>
      <div>
        <FormControlLabel
          name="defaults"
          disabled={!(options?.email)}
          label="Include data table in email body"
          control={
            <Checkbox
              checked={options["email-tables"] ?? false}
              onChange={(event) => {
                const value = event.target.checked;
                setOptions({
                  "email-tables": value,
                });
              }}
              name="emailTables"
            />
          }
        />
        <FormControlLabel
          name="csvattach"
          disabled={!(options?.email)}
          label="Attach CSV in email (limited to 2MB size)"
          control={
            <Checkbox
              checked={options["emailattachment"] ?? false}
              onChange={(event) => {
                const value = event.target.checked;
                setOptions({
                  "emailattachment": value,
                });
              }}
              name="emailAttachment"
            />
          }
        />
      </div>
          <Autocomplete
            multiple
            options={Object.values(availableGroups)}
            getOptionLabel={(option) => option.name || option.id}
            value={groups}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            onChange={(e, val) => updateGroups(val)}
            //              val.filter((v, i, arr) => arr.findIndex(x => x.id === v.id) === i))}
            renderInput={(params) => (
              <TextField {...params} label="
              Allow these groups to change report" placeholder="" />
            )}
            sx={{ width: '500px' }}
          />          
      <div>
        
      </div>
      <div className={classes.option}>
      </div>
      <FormLabel component="legend">Spreadsheet Format</FormLabel>
      <FormControl
        variant="standard"
        margin="dense"
        fullWidth={true}
        style={{ marginTop: 11 }}>
        <InputLabel >
          Data in the spreadsheet will be organized:
        </InputLabel>
        <Select
          variant="standard"
          labelId="spdtype"
          id="spdtype1"
          value={options["data-format"] ?? "2"}
          onChange={(event) => {
            const value = event.target.value;
            setOptions({
              "data-format": value,
            });
          }}
          input={<Input />}
          /*renderValue={(selected) => (
            <div style={{ fontSize: ".75rem" }}>{selected.join(",")}</div>
          )}*/>
          {Object.keys(dataTypeOptions).map((value) => (
            <MenuItem dense key={value} value={value}>
              {dataTypeOptions[value]}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <div style={{ "marginTop": "10px" }}>
        <FormControlLabel
          name="defaults"
          label="Export tags as separate files"
          control={
            <Checkbox
              checked={!(options?.["one-file"] ?? true)}
              onChange={(event) => {
                const value = event.target.checked;
                setOptions({
                  "one-file": !value,
                });
              }}
              name="useSingle"
            />
          }
        />
        <FormControlLabel
          name="defaults"
          label="Exclude header row"
          control={
            <Checkbox
              checked={!(options?.["include-header"] ?? true)}
              onChange={(event) => {
                const value = event.target.checked;
                setOptions({
                  "include-header": !value,
                });
              }}
              name="useSingle"
            />
          }
        />
        <FormControlLabel
          name="defaults"
          label="Preserve Tag Order"
          control={
            <Checkbox
              checked={!(options?.["sort-alpha"] ?? true)}
              onChange={(event) => {
                const value = event.target.checked;
                setOptions({
                  "sort-alpha": !value,
                });
              }}
              name="sortalpha"
            />
          }
        />
      </div>
      {false &&
        <FormControl variant="standard">
          <FormLabel id="demo-radio-buttons-group-label">Format</FormLabel>
          <RadioGroup
            aria-labelledby="demo-radio-buttons-group-label"
            defaultValue="1"
            name="data-format"
            value={options["data-format"] ?? "2"}

          >
            <FormControlLabel value="1" control={<Radio onChange={(event) => {
              const value = event.target.value;
              setOptions({
                "data-format": value,
              });
            }} />} label="Show tag data in columns" />
            <FormControlLabel value="2" control={<Radio onChange={(event) => {
              const value = event.target.value;
              setOptions({
                "data-format": value,
              });
            }} />} label="Show tag data in rows" />
            <FormControlLabel value="3" control={<Radio onChange={(event) => {
              const value = event.target.value;
              props.setOptions({
                "data-format": value,
              });
            }} />} label="Show tag data linearly" />
          </RadioGroup>
        </FormControl>
      }
      {false &&
        <FormControlLabel
          name="defaults"
          label="Recur"
          control={
            <Switch
              onChange={(event) => {
                const value = event.target.checked;
                let newOptions = { ...timeframe, type: value ? "moving" : "fixed" };
                if (value === "fixed" && timeframe.start == null) {
                  newOptions.start = moment();
                }
                props.setOptions({ timeframe: newOptions });
              }}
              name="recurswitch"
            />
          }
        />
      }
      {false &&
        <FormControl variant="standard">
          <TextField
            variant="standard"
            id="start-time"
            label="Start Date Time eg. 2025-03-24T15:30:00Z"
            value={options.start ?? ""}
            onChange={(event) => {
              const val = event.target.value;
              setOptions({ start: val });
            }} />
        </FormControl>
      }
      {false &&
        <FormControl variant="standard">
          <TextField
            variant="standard"
            id="end-time"
            label="End Date Time"
            value={options.end ?? ""}
            onChange={(event) => {
              const val = event.target.value;
              setOptions({ end: val });
            }} />
        </FormControl>
      }
      {options["recur"] && false &&
        <FormControl variant="standard">
          <TextField
            variant="standard"
            id="recur"
            label="Advance sample range by and repeat export every N days (optional positive integer - default ot no repeat)"
            value={options["recur-days"] ?? ""}
            onChange={(event) => {
              const val = event.target.value;
              setOptions({ "recur-days": val });
            }} />
        </FormControl>
      }
      {options["recur"] && false &&
        <FormControl variant="standard">
          <TextField
            variant="standard"
            id="exec_at"
            label="Timestamp after which to first execute"
            value={options["execute-after"] ?? ""}
            onChange={(event) => {
              const val = event.target.value;
              setOptions({ "execute-after": val });
            }} />
        </FormControl>
      }
    </FormControl>
  );
};

export default ExportOption;
